import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "header_title fs28 fl mr10"
}
const _hoisted_2 = {
  key: 0,
  class: "fl fs14 underline pointer",
  style: {"margin-top":"38px"}
}
const _hoisted_3 = {
  key: 1,
  class: "fl fs14 underline pointer",
  style: {"margin-top":"38px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "投票中のメンバーはいません", -1)
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_SuggestedRoomsForAll = _resolveComponent("SuggestedRoomsForAll")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`fl centered ${_ctx.canShowVotedPage && _ctx.showVotedPage ? `w100` : ``}`)
  }, [
    (_ctx.showHeaderTitle)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.$t(_ctx.headerTitle)), 1))
      : _createCommentVNode("", true),
    (_ctx.canShowVotedPage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fl",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickVotedPageButton && _ctx.clickVotedPageButton(...args)))
        }, [
          (!_ctx.showVotedPage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "投票状況を見る"))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, "閉じる")),
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    _hoisted_5,
    (_ctx.canShowVotedPage && _ctx.showVotedPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (!_ctx.votedRooms)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_RoomsLoader)
              ]))
            : (_ctx.votedRooms.length == 0 || _ctx.room?.rooms_voted_summary?.suggested_dates?.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                    width: "40",
                    height: "40"
                  }, null, 8, _hoisted_10)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_SuggestedRoomsForAll, {
                    room: _ctx.room,
                    rooms: _ctx.votedRooms,
                    onlyShowDates: _ctx.onlyShowDates,
                    onFixedAppo: _ctx.fixedAppo
                  }, null, 8, ["room", "rooms", "onlyShowDates", "onFixedAppo"])
                ]))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}